import { TicketingFormCategory, DonationFormCategory } from "@simplyk/common";

import { TicketingOutput } from "@/common/types/trpc";
import { hasReminderEligibleDate } from "@/common/helpers/ticketing";
import { trpc } from "@/common/helpers/trpc";

type UseLiveFormRemindersDataArgs = {
  formCategory: TicketingFormCategory | DonationFormCategory;
  recurrences?: TicketingOutput["recurrences"];
  ticketingId?: string;
};

export type LiveFormRemindersState = {
  showReminders: boolean;
};

export const useLiveFormRemindersData = ({
  formCategory,
  recurrences,
  ticketingId,
}: UseLiveFormRemindersDataArgs): LiveFormRemindersState => {
  const isEventForm = formCategory === TicketingFormCategory.Event;

  const shouldQueryReminders = Boolean(ticketingId && isEventForm);

  const { data: isTicketingHasRemindersV1 } = trpc.isTicketingHasRemindersV1.useQuery(
    { ticketingId: ticketingId ?? "" },
    { enabled: shouldQueryReminders }
  );

  const hasEligibleDate = hasReminderEligibleDate(recurrences);

  const showReminders = Boolean(!isTicketingHasRemindersV1 && isEventForm && hasEligibleDate);

  return { showReminders };
};
